export default defineNuxtRouteMiddleware((to, from) => {
  if (decodeURIComponent(to.path).includes("referrerId=")) {
    return navigateTo(decodeURIComponent(to.path));
  }
});
